import React from 'react';

//components
import PageHeader from '../../../PageHeader/PageHeader.js'
import PageInfo from '../../components/PageInfo.js';
import PageState from '../../components/PageState.js';

//Styles
import stylesList from "../../OmOs/DetTrorViPaa/Index.module.css"
import styles from "./Gudstjeneste.module.css"

export default function Gudstjenesten() {

    return(
        <PageState
            pageName="Gudstjeneste"
            render={({ data, sections, sectionNames }) => {

                const {Sec1, Sec2, Sec3} = data;
                console.log("sections:", sections);
                console.log("sectionNames:", sectionNames);
                console.log(Sec1.secId)
                console.log(Sec1)
                
                return (

                    <div>
                        <PageHeader 
                            image={data.PageHeader.imageUrl} 
                            title={data.PageHeader.title} 
                            description={data.PageHeader.text} 
                            sections={sections}
                            sectionNames={sectionNames}>
                        </PageHeader>
                        {/* Forvente */}
                        <section id ={Sec1.secId} className={styles.sec1}>  {/* to ensure the scrollable nav function, we need to split the page into sections, 
                                                    with its headline as id, matching the section list */}
                            <PageInfo  
                                title={Sec1.header} 
                                description={<div dangerouslySetInnerHTML={{ __html: Sec1.text }}/>} 
                                image={Sec1.imageUrl} 
                                version={"v1"}/>
                        </section>

                        {/* Centrale elementer */}
                        <section id = {Sec2.secId}>
                            <div className={stylesList.fundamentet}>
                                <div className={stylesList.backgroundImage} style={{ backgroundImage: `url(${Sec2.imageUrl})`, backgroundPosition: "center"}}></div>
                                <div className={stylesList.fundamentetInfo}>
                                    <h1>{Sec2.header}</h1>
                                    <p>{Sec2.text}</p>
                                </div>
                            </div>
                            <div>
                                <div className={stylesList.listItem1}>
                                    <div>
                                        <h2 className={stylesList.listItemTitle}>{Sec2.item1.title}</h2>
                                        <div className={stylesList.listItemText1} dangerouslySetInnerHTML={{ __html: Sec2.item1.text }}/>
                                    </div>
                                </div>
                                <div className={stylesList.listItem2}>
                                    <div>
                                        <h2 className={stylesList.listItemTitle}>{Sec2.item2.title}</h2>
                                        <div className={stylesList.listItemText2} dangerouslySetInnerHTML={{ __html: Sec2.item2.text }}/>
                                    </div>
                                </div>
                                <div className={stylesList.listItem1}>
                                    <div>
                                        <h2 className={stylesList.listItemTitle}>{Sec2.item3.title}</h2>
                                        <div className={stylesList.listItemText1} dangerouslySetInnerHTML={{ __html: Sec2.item3.text }}/>
                                    </div>
                                </div>
                                <div className={stylesList.listItem2}>
                                    <div>
                                        <h2 className={stylesList.listItemTitle}>{Sec2.item4.title}</h2>
                                        <div className={stylesList.listItemText2} dangerouslySetInnerHTML={{ __html: Sec2.item4.text }}/>
                                    </div>
                                </div>
                                <div className={stylesList.listItem1}>
                                    <div>
                                        <h2 className={stylesList.listItemTitle}>{Sec2.item5.title}</h2>
                                        <div className={stylesList.listItemText1} dangerouslySetInnerHTML={{ __html: Sec2.item5.text }}/>
                                    </div>
                                </div>
                                <div className={stylesList.listItem2}>
                                    <div>
                                        <h2 className={stylesList.listItemTitle}>{Sec2.item6.title}</h2>
                                        <div className={stylesList.listItemText2} dangerouslySetInnerHTML={{ __html: Sec2.item6.text }}/>
                                    </div>
                                </div>
                            </div>
                        
                        </section>
                        {/* For Børn */}
                        {/* <section className={styles.sec4} id ={Sec4.id}>
                            <h1>{Sec4.header}</h1>
                            <div className={styles.sec4Text} dangerouslySetInnerHTML={{ __html: Sec4.text }}/>
                            <div className={styles.actionWrapper}>
                                <div className={styles.bntWrapper}>
                                    <a 
                                        href={Sec4.item1.link} 
                                        className={styles.memberBnt}
                                        style={{ backgroundImage: `url(${Sec4.item1.imageUrl})` }}>
                                        <h3 className={styles.bntCaption}>
                                            {Sec4.item1.title}
                                        </h3>
                                    </a>
                                </div>
                                <div className={styles.bntWrapper}>
                                    <a 
                                        href={Sec4.item2.link} 
                                        className={styles.memberBnt}
                                        style={{ backgroundImage: `url(${Sec4.item2.imageUrl})` }}>
                                        <h3 className={styles.bntCaption}>
                                            {Sec4.item2.title}
                                        </h3>
                                    </a>
                                </div>
                            </div>
                        </section> */}
                        {/* Gudstjeneste i Gilleleje */}
                        <section id={Sec3.secId} className={styles.sec3}>
                            <PageInfo 
                                title={Sec3.header}
                                image={Sec3.imageUrl}
                                description={<div dangerouslySetInnerHTML={{ __html: Sec3.text }}/>}
                                version={"v2"}/>
                        </section>
                    </div>
                );
            }
        }/>
    );
}